import axios from '@service'
import { getMarginPaymentInfoApi } from './api'
import { HTTP_ERR_SUCCESS } from '@constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@constant/error'

// 保证金缴纳信息
export default async function getMarginPaymentInfoService(payload = {}, config = {}, sytemType) {
    const param = {
        ...getMarginPaymentInfoApi(sytemType),
        ...config,
        params: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
